import InvalidSourcesAlert from "./InvalidSourcesAlert"

export default InvalidSourcesAlert
